import { type FC } from "react";

import styled from "@emotion/styled";
import { Button, Colors } from "@snapchat/snap-design-system";
import { AddIcon } from "@snapchat/snap-design-system-icons";

import { Visible } from "./Visible";

interface DropdownWithCreateNewProps {
    text: string;
    menuNode: React.ReactNode;
    showModal: () => void;
    showCreateButton?: boolean;
    "data-testid"?: string;
}

export const DropdownWithCreateNew: FC<DropdownWithCreateNewProps> = ({
    menuNode,
    text,
    showModal,
    showCreateButton = true,
    "data-testid": dataTestId,
}) => (
    <>
        {menuNode}
        <Visible when={showCreateButton}>
            <DropdownFooter>
                <Button type="link" onClick={showModal} data-testid={dataTestId}>
                    <AddIcon fill={Colors.Blue.V100} />
                    {text}
                </Button>
            </DropdownFooter>
        </Visible>
    </>
);

const DropdownFooter = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 7px 0;
`;
